import script from "./OrderFileEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderFileEdit.vue?vue&type=script&setup=true&lang=js"

import "./OrderFileEdit.vue?vue&type=style&index=0&id=1ec3f095&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec3f095"]])

export default __exports__